var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"person-page page"},[_c('h1',[_c('Locale',{attrs:{"path":'routes.' + _vm.$route.name}})],1),_c('person-explorer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }